/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class e{constructor(e,m,t){this.maximumTotalNumberOfVertices=e,this.maximumNumberOfFeatures=m,this.averageSymbolComplexity=t}}export{e as DisplayFeatureLimit};
